import { useEffect } from 'react'

import { useFilters, useSearchParams } from '@/hooks'
import { MarketShopCategoryModel } from '@/models'

import { MarketShopInventoryFilters } from './market-shop-inventory.constants'

interface UseDefaultFilteringProps {
  searchParams: ReturnType<typeof useSearchParams>
  filters: ReturnType<typeof useFilters<MarketShopInventoryFilters>>
  categories?: MarketShopCategoryModel[]
}

export const useDefaultFiltering = ({
  searchParams,
  filters,
  categories,
}: UseDefaultFilteringProps) => {
  useEffect(() => {
    if (searchParams.parsedQuery.sortBy || searchParams.parsedQuery.sortOrder) {
      return
    }

    filters.setFilters((prev) => ({
      ...prev,
      sortBy: 'inStock',
      sortOrder: 'asc',
    }))
  }, [])

  // Note: A category selected here can be deleted from Market Setup, which would
  // otherwise leave the filter pointing at an id the API no longer knows about.
  useEffect(() => {
    if (!categories) return

    const selectedCategoryId = filters.getFilter('categoryId') ?? []
    if (selectedCategoryId.length === 0) return

    const availableCategoryId = new Set<number | string>([
      'all',
      ...categories.map((category) => category.id),
    ])
    const nextCategoryId = selectedCategoryId.filter((id) => availableCategoryId.has(id))
    if (nextCategoryId.length === selectedCategoryId.length) return

    filters.setFilter('categoryId', nextCategoryId)
  }, [categories])
}
